import React from 'react';

import VipCrownIcon from '@/assets/vip-crown.svg?react';
import { UiTypography } from '@/components/ui/Typography';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import {
  OneDayVIPCardStyles,
  OneDayVIPContentContainerStyles,
  OneDayVIPContentStyles,
  OneDayVIPIconStyles,
  OneDayVIPTitleStyles,
  OneDayVIPDescriptionStyles,
  OneDayVIPPriceStyles,
} from './OneDayVIPSubscriptionData.styles';

export const OneDayVIPSubscriptionData: React.FC<{
  subscription: StripeV2SubscriptionPrice;
  vipTitle?: string;
}> = ({ subscription, vipTitle }) => {
  return (
    <OneDayVIPContentStyles>
      <OneDayVIPContentContainerStyles>
        <OneDayVIPCardStyles>
          <OneDayVIPIconStyles>
            <VipCrownIcon />
          </OneDayVIPIconStyles>

          <OneDayVIPTitleStyles variant={'title-medium'}>
            {vipTitle || 'One Day Premium'}
          </OneDayVIPTitleStyles>

          <OneDayVIPDescriptionStyles
            variant={'body-medium'}
            color={'neutral-white'}
          >
            Try everything — one day, no limits.
          </OneDayVIPDescriptionStyles>

          <OneDayVIPPriceStyles>
            <UiTypography
              variant={'body-medium'}
              color={'neutral-white'}
              className={'original-price'}
            >
              ${subscription.original_price}
            </UiTypography>
            <UiTypography variant={'body-medium'}>→</UiTypography>
            <UiTypography variant={'title-medium'}>
              ${subscription.price}
            </UiTypography>
          </OneDayVIPPriceStyles>
        </OneDayVIPCardStyles>
      </OneDayVIPContentContainerStyles>
    </OneDayVIPContentStyles>
  );
};
